const RecipeConstants = {
  RECIPE_GENERATE_SUCCESS: 'RECIPE_GENERATE_SUCCESS',
  RECIPE_GENERATE_FAILURE: 'RECIPE_GENERATE_FAILURE',
  INGREDIENTS_INVENTORY_SUCCESS:'INGREDIENTS_INVENTORY_SUCCESS',
  INGREDIENTS_INVENTORY_FAILURE:'INGREDIENTS_INVENTORY_FAILURE',
  SELECTED_INGREDIENTS_UPDATE: 'SELECTED_INGREDIENTS_UPDATE',
  SELECTED_INGREDIENTS_CLEAR: 'SELECTED_INGREDIENTS_CLEAR',
  RECIPES_SUGGESTIONS_SUCCESS: 'RECIPES_SUGGESTIONS_SUCCESS',
  RECIPES_SUGGESTIONS_UPDATE: 'RECIPES_SUGGESTIONS_UPDATE',
  RECIPES_SUGGESTIONS_FAILURE: 'RECIPES_SUGGESTIONS_FAILURE',
  RECIPES_GENERATE_SUCCESS: 'RECIPES_GENERATE_SUCCESS',
  RECIPES_GENERATE_FAILURE: 'RECIPES_GENERATE_FAILURE',
  RECIPE_SELECT_UPDATE: 'RECIPE_SELECT_UPDATE',
  SUGGESTED_RECIPE_CLEAR: 'SUGGESTED_RECIPE_CLEAR',
  ANALYZE_INGREDIENTS_SUCCESS: 'ANALYZE_INGREDIENTS_SUCCESS',
  ANALYZE_INGREDIENTS_FAILURE: 'ANALYZE_INGREDIENTS_FAILURE',
  CLEAR_ANALYZE_STATUS: 'CLEAR_ANALYZE_STATUS'

};

export default RecipeConstants;